var TscButtonRounding = {
  circle: 'circle',
  roundedEdges: 'roundedEdges',
  default: 'default'
};
export default TscButtonRounding;